<script setup lang="ts">
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";

const props = defineProps<{
  icon?: IconDefinition,
  iconVariant?: 'warning' | 'danger',
  minHeight?: number
}>()

const modalStyles = computed(() => {
  const styles: Record<string, string> = {};
  if (props.minHeight !== undefined) {
    styles['min-height'] = `${props.minHeight}px`;
  }
  return styles;
});
</script>

<template>
  <div
  :class="[$style['modal-content'], { [$style['has-icon']]: !!icon }]"
  :style="modalStyles"
  class="d-flex flex-1"
>
    <FontAwesomeIcon v-if="icon" :icon="icon" :class="[{ [`text-${iconVariant}`]: iconVariant }, $style['icon']]" />

    <div class="w-100">
      <slot />
    </div>
  </div>
</template>

<style module lang="scss">
.modal-content.has-icon {
  > :global(.w-100) {
    margin-left: 25px;
  }
}

.modal-content {
  overflow: auto;
  margin-top: 25px;
  overscroll-behavior: contain;

  > :global(.w-100) {
    margin-top: 0;
  }
}

.icon {
  font-size: 45px;
}
</style>
